module.exports = __webpack_public_path__ + "423e890950d662898d7d1b7851a0d82a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/10-dogs.svg
// module id = 72
// module chunks = 0